<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="优选厂商" />
		<el-button class="add-btn" @click="handleAdd">添加</el-button>
		<el-table :data="tableData" border>
			<el-table-column fixed class="photo"  label="公司logo">
				<template slot-scope="scope">
					<img :src="scope.row.photo"  alt="">
				</template>
			</el-table-column>
			<el-table-column fixed prop="title" label="公司名称" />
			<el-table-column prop="url" label="链接地址" />
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="handleJump(scope.row)">编辑</el-button>
					<el-popconfirm title="确认删除吗？" @confirm="handleDel(scope.row)">
						<el-button type="text" size="small" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog
		  :title="titles"
		  :visible.sync="dialogVisible"
		  width="40%"
		  :before-close="handleClose">
		 <el-form :model="form" :rules="rules"  ref="form" >
		     <el-form-item prop="title" label="公司名称" >
		       <el-input v-model="form.title"  autocomplete="off"></el-input>
		     </el-form-item>
			 <el-form-item label="logo"  prop="photo">
			 	<el-upload class="avatar-uploader" :action="picUrl" :show-file-list="false"
			 		element-loading-text="拼命加载中……"
			 		:on-progress="change"
			 		:before-upload="beforeAvatarUpload"
			 		:data="fileInfo"
			 		:on-success="handleAvatarSuccess" accept="image/jpeg,image/png">
			 		<img v-if="imageUrl" :src="imageUrl"  :onerror="imgSrc" class="avatar">
			 		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			 	</el-upload>
			 	<div class="tishinews">
			 		小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
			 		<!-- <br/>图片建议比例:3:2 -->
			 	</div>
			 </el-form-item>
			 
		    <el-form-item prop="url" label="链接地址">
		      <el-input v-model="form.url"  autocomplete="off"></el-input>
		    </el-form-item>
		   </el-form>
		   <div slot="footer" class="dialog-footer">
		     <el-button @click="quxiao">取 消</el-button>
		     <el-button type="primary" @click="sumbmitForm">确 定</el-button>
		   </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading:false,
				imageUrl:'',
				fileInfo:{
					type:"Goods",
				},
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				picUrl:'',
				tableData: [],
				titles:"",
				dialogVisible:false,
				form:{
					title:'',
					url:'',
					photo:'',
					id:''
				},
				rules:{
					title: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.title === '') {
								callback(new Error('请输入链接名称'));
							} else {
								callback();
							}
						}
					}],
					photo:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.photo === '') {
								callback(new Error('请上传图片'));
							} else {
								callback();
							}
						}
					}],
					url: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.url === '') {
								callback(new Error('请输入链接地址'));
							} else {
								callback();
							}
						}
					}],
				}
			}
		},
		created() {
			this.getData()
			this.picUrl = this.$store.state.BASE_URL+'/uploadImgOne.html'
		},
		methods: {
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			change(event, file, fileList){
				this.loading = true;
			},
			handleAvatarSuccess(res, file) {
				if(res.src != null){
					this.loading = false;
					this.form.photo = res.src
					this.imageUrl = URL.createObjectURL(file.raw);
				}else{
					this.loading = false;
					this.$message.error(res.data);
				}
			},
			getData() {
				this.$axios.post('Myseller-SellerManage-companyList', {
					// typeid:12,
					user_id: this.$store.state.USER_ID,
				}).then(data => {
					this.tableData = data
					document.body.scrollTop = document.documentElement.scrollTop = 0
				})
			},
			currentChange(page) {
				this.p = page
				this.getData()
			},
			handleClose(){
				this.dialogVisible = false
				this.imageUrl=""
				this.$refs['form'].resetFields();
			},
			handleJump(row) {
				this.titles = "编辑优选厂商"
				this.dialogVisible = true
				this.form.id=row.id
				this.form.photo = row.photo
				this.form.url = row.url
				this.form.title = row.title
				this.imageUrl = row.photo
				
			},
			handleAdd() {
				this.titles = "添加优选厂商"
				this.dialogVisible = true
				
			},
			quxiao(){
				this.dialogVisible = false
				this.imageUrl=""
				this.$refs['form'].resetFields();
			},
			sumbmitForm(row){
				this.$refs['form'].validate(valid => {
					if (valid) {
						let title = this.form.title
						let url = this.form.url
						let photo = this.form.photo
						let id = this.form.id
						this.$axios.post('Myseller-SellerManage-addCompanyList',{
							id,
							title,
							url,
							photo
						}).then(data => {
							if(data==0 || data >0){
								this.dialogVisible = false
								this.getData()
								
							}else{
								this.$message({
									type: 'error',
									message: data.msg
								})
							}
							this.$refs['form'].resetFields();
						})
					}
				})
				
			},
			handleDel(row) {
				this.$axios.post('Myseller-SellerManage-delCompanyList', {
					user_id:this.$store.state.USER_ID,
					id: row.id
				}).then(data => {
					this.$message({
						type: 'success',
						message: '删除成功'
					})
					this.getData();
				})
			},
		}
	}
</script>

<style scoped>
	.el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
	.o-wrap>>>.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.o-wrap>>>.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.o-wrap>>>.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	.el-upload img{
		width: 178px;
		height: 178px;
	}
	.cell img{
		width: 100px;
		height: 100px;
	}
</style>
